export default {
    methods: {
        // Geeft minimaal aantal penumbra per klasse terug
        minimaalAantalPenumbra(klasse){
            let minPenumbra = 1
            switch (klasse) {
                case 'A':
                    minPenumbra = 0
                    break;
                case 'B':
                    minPenumbra = 0
                    break;
                case 'C':
                    minPenumbra = 1
                    break;
                case 'D':
                    minPenumbra = 2
                    break;
                case 'E':
                    minPenumbra = 2
                    break;
                case 'F':
                    minPenumbra = 2
                    break;
                case 'G':
                    minPenumbra = 2
                    break;
                case 'H':
                    minPenumbra = 1
                    break;
                case 'J':
                    minPenumbra = 1
                    break;
                default:
                    minPenumbra = 0
            }
            return minPenumbra
        },
        minimaalAantalVlekken(klasse){
            let minVlekken = 1
            switch (klasse) {
                case 'A':
                    minVlekken = 1
                    break;
                case 'B':
                    minVlekken = 2
                    break;
                case 'C':
                    minVlekken = 2
                    break;
                case 'D':
                    minVlekken = 2
                    break;
                case 'E':
                    minVlekken = 2
                    break;
                case 'F':
                    minVlekken = 2
                    break;
                case 'G':
                    minVlekken = 2
                    break;
                case 'H':
                    minVlekken = 1
                    break;
                case 'J':
                    minVlekken = 1
                    break;
                default:
                    minVlekken = 1
            }
            return  minVlekken
        },
// Geeft de toegestane letters voor de verdeling van vlekken in groepen
        toegestaanVerdeling(klasse) {
            let allowed = ['x', 'o', 'i', 'c']
            if (klasse === '') {
                allowed = []
            } else if (klasse === 'A' || klasse === 'H' || klasse === 'J') {
                allowed = ['x']
            } else if (klasse === 'B') {
                allowed = ['o', 'i']
            } else if (klasse === 'C') {
                allowed = ['o', 'i']
            } else {
                allowed = ['o', 'i', 'c']
            }
            return allowed
        },

        // Geeft de toegestane letters voor de vorm van de penumbra in groepen
        toegestaanLettersPenumbra(klasse) {
            let allowed = ['x', 'r', 's', 'a', 'h', 'k']
            if (this.klasse === '') {
                allowed = []
            } else if (this.klasse === 'A' || this.klasse === 'B') {
                allowed = ['x']
            } else {
                allowed = ['r', 's', 'a', 'h', 'k']
            }
            return allowed
        },

        // Geeft gesorteerde beckwaarden terug
        sortedBeckDetails(beckDetail) {
            if (beckDetail != null && beckDetail.includes(";")) {
                let parts = beckDetail.split(";").sort()
                return parts.filter(Boolean).join(";")
            } else {
                return beckDetail
            }
        },

        // Geeft gesorteerde beckwaarden terug na verwijdering van een groep
        deleteDetailFromBeckDetails(beckDetail, groep) {
            let parts = beckDetail.split(";")
            let index = parts.indexOf(groep)
            if (index !== -1) {
                parts.splice(index, 1)
            }
            return this.sortedBeckDetails(parts.filter(Boolean).join(";"))
        },

        // Geeft gesorteerde cv waarden terug
        sortedCvDetails(cvDetail){
            if(cvDetail != null && cvDetail.includes(";")){
                let parts = cvDetail.split(";").sort()
                return parts.filter(Boolean).join(";")
            } else {
                return cvDetail
            }
        },

        // Geeft gesorteerde cv waarden terug na verwijdering van een groep
        deleteDetailFromCvDetails(cvDetail, groep){
            let parts = cvDetail.split(";")
            let index = parts.indexOf(groep)
            if (index !== -1) {
                parts.splice(index, 1)
            }
            return this.sortedBeckDetails(parts.filter(Boolean).join(";"))
        },

    }

}